import { render, staticRenderFns } from "./bip-form.vue?vue&type=template&id=ce8adb46&"
import script from "./bip-form.vue?vue&type=script&lang=ts&"
export * from "./bip-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports